import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectAddonById, setEditId } from "../../../store/mine_craft/addonsSlice";
import { destroyAddon, fetchAddon } from "../../../actions/mine_craft/addonsActions";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";

import {
  LikeOutlined,
  MessageOutlined,
  StarOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import {Image, message} from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Details from "./_partials/_Details";
import Comments from "./_partials/_Comments";
import { ButtonDestroy, ButtonDownload, ButtonEdit } from "../../../componets/Buttons";
import EditComment from "../Comments/Edit";
import usePermissions from "../../../hooks/usePermissions";

const TARGET_ID = 1;

const Show: React.FC = () => {
  const { id }    = useParams();
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const addon      = useAppSelector(state => id ? selectAddonById(state, id) : undefined);
  const { write_minecraft } = usePermissions();

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchAddon(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (addon) {
      dispatch(setEditId(addon.id));
    }
  }

  function onClickDestroy() {
    if (addon) {
      handleDestroy(addon.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAddon(id));

    if (destroyAddon.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(minecraftUrls.addonsPath()), 1000);
    }

    if (destroyAddon.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-addons-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            addon &&
              <SummaryShow
                title={addon.title}
                image={addon.image_url}
                createdAt={addon.created_at}
                updatedAt={addon.updated_at}
                className='v-mb-15'
                actions={[
                  ...(addon.zip_url ? [<ButtonDownload key='button-download' href={addon.zip_url} />] : []),
                  ...(write_minecraft ? [
                    <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                    <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                  ] : [])
                ]}
              />
          }

          <StatsIcons
            icons={[
              <Image src={addon?.ico_url} width={14} height={14} preview={false} style={{ marginTop: -4 }}/>,
              <IconText tooltip='popular' icon={StarOutlined} text={addon?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={addon?.likes_count} />,
              <IconText tooltip='downloads' icon={DownloadOutlined} text={addon?.downloads_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={addon?.comments_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          items={[
            { label: 'Details', key: 'details', children: <Details addon={addon} /> },
            { label: 'Comments', key: 'comment', children: <Comments addonId={addon?.id} /> }
          ]}
        />
      </div>

      <SidebarShow addon={addon} />

      <Edit />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
